
import React, { useState } from "react"
import { md, pki } from "node-forge"
import classNames from "classnames"
import GeneratePrivateKey from "./GeneratePrivateKey.jsx"
import KeyUpload from "./KeyUpload.jsx"
import P12Download from "./P12Download.jsx"

const P12Dialog = ({csrfToken, certPemElements}) => {

  const [privateKey, setPrivateKey] = useState(null)
  const [password, setPassword] = useState(null)
  const [enabled, setEnabled] = useState(true)

  const handleKeyUpload = (key, password) => {
      setPrivateKey(key)
      setPassword(password)
  }

  if (!enabled) {
      return (<div>
        <button className="btn btn-secondary" onClick={() => setEnabled(true)}>
          Enable PKCS12 bundle tool
        </button>
      </div>)
  }

  const certPems = Array.from(certPemElements).map(x => x.textContent)

  return (<>
      <div className="card my-2">
        <h5 className="card-header">Create PKCS12</h5>
        <div className="card-body">
          <KeyUpload
              onKeyUpload={(key, password) => handleKeyUpload(key, password)}
          />
          { (certPems.length && privateKey) && <>
            <hr />
            <P12Download certPems={certPems} password={password}
                         privateKey={privateKey} />
          </>}
        </div>
      </div>
  </>)
}

export default P12Dialog
